import React from 'react';
import { MixpanelContext } from '@weezevent/nacre';

export default function useMixpanel() {
    const context = React.useContext(MixpanelContext);

    return context;
}
